import { Link } from '../../../api/contract-notice-dto';
import {
  BaseEntityDTO, BaseObjectDTO, DivisionDTO, DocumentClassDTO,
  LinkedActionsDTO, TaskDTO
} from '../../../api/plyca-dtos';

import { ContractDTO, ObjectContextDTO, WarrantyDTO } from '../../../api/plyca-dtos-v2';



export class GuaranteeRefundDTO implements BaseEntityDTO {
  division: DivisionDTO;
  documentClass: DocumentClassDTO;
  orderNumber: number;
  links: Link[];
  identifier: any;
  task: TaskDTO;
  contract: ContractDTO;
  registerNumberContractModificacion: string;
  observations: string;
  listWarrantyPayments: GuaranteePaymentsDTO[];
  context?: ObjectContextDTO;
  projectOrganizationalSnapshot?: any;
  previousOrganizationalUnitRegistration: boolean;
}

// TODO ver si hay ue incluirlo en plyca-dtos.ts
export class WorkGuaranteeRefundDTO implements BaseObjectDTO<string> {
  identifier: string;
  links: Link[];
  context?: ObjectContextDTO;
  guaranteeRefund: GuaranteeRefundDTO;
  reactive: boolean;
  task: TaskDTO;
  availableActions: LinkedActionsDTO;
}

export class GuaranteePaymentsDTO {
  identifier: string;
  amount: number;
  constitutionDate: Date;
  agreementDate: Date;
  editable = true;
  warranty: WarrantyDTO;
}